import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toPng, toBlob } from "html-to-image";

import Answers from "./Mcq/answers";
import Question from "./Mcq/question";
import Image from "./Mcq/Image";
import MtfQuestion from "./Mtf/question";
import OptionsContainer from "./Mtf/optionsContainer";
import { useDispatch } from "react-redux";
import { updateContainerImage, updateSelectedComponentType, updateThumbnailImg } from "../../../redux/slices/userActivity";
import { useRef } from "react";
import TandF from "./TrueandFalse/TandF";
import { convertLinkToDataUrl } from "../../../utils";
import html2canvas from "html2canvas";

import useWindowDimensions from "../../../hooks/useWindowDimensions";

import Timer from "./activityTools/Timer/timer";
import FillUpsAnswers from "./FillUps/fillUpsAnswers";
import { useDisableBodyScroll } from "../../../hooks/useDisableBodyScroll";
import MatchingPairs from "./matchingPairs";
import CrossWords from "./_games/CrossWords";
import Video from "./Video/Video";

export default function ActivityBox({ master }) {
  const { width } = useWindowDimensions();
  const [styles, setStyles] = useState({});
  const activityRef = useRef();

  const dispatch = useDispatch();
  let timeout;

  const { selectedUserActivity, userActivities } = useSelector((state) => state.userActivity);
  const { modalOpen: previewModalOpen, isMobile } = useSelector((state) => state.preview);

  useDisableBodyScroll(previewModalOpen);

  const update = () => {
    // toBlob(activityRef.current)
    //   .then((dataUrl) => {
    //     const link = document.createElement("a");
    //     // link.download = "my-image-name.png";
    //     if (dataUrl) dispatch(updatePaginationImg({ selectedActivityIdx: selectedUserActivity, img: dataUrl }));
    //     var reader = new FileReader();
    //     reader.onloadend = function () {
    //       // dispatch(
    //       //   updateThumbnailImg({
    //       //     selectedActivityIdx: selectedUserActivity,
    //       //     name: "test.png",
    //       //     uri: reader.result,
    //       //   })
    //       // );
    //     };
    //     reader.readAsDataURL(dataUrl);
    //     clearTimeout(timeout);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    if (previewModalOpen) return;
    html2canvas(activityRef.current, {
      allowTaint: true,
      useCORS: true,
    }).then(function (canvas) {
      canvas.getContext("2d");
      var imgData = canvas.toDataURL("image/jpeg", 1.0);
      // if (imgData) dispatch(updatePaginationImg({ selectedActivityIdx: selectedUserActivity, img: imgData }));
      dispatch(
        updateThumbnailImg({
          selectedActivityIdx: selectedUserActivity,
          name: "test.png",
          uri: imgData,
        })
      );
      clearTimeout(timeout);
    });
  };

  useEffect(() => {
    if (previewModalOpen) return;
    if (activityRef.current === null) return;

    if (!master) return;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      update();
    }, 500);
    return () => {
      clearTimeout(timeout);
    };
  }, [master?.question_id, master?.theme_id?.styles]);

  const handleClick = (e) => {
    if (e.target.classList.contains("activity_container__activity_wrapper")) {
      dispatch(
        updateSelectedComponentType({
          type: "slide",
          name: "container",
        })
      );
    }
  };

  useEffect(() => {
    if (master?.question_id?.background_image !== null) {
      if (!master?.question_id?.background_image_data) {
        convertLinkToDataUrl(master?.question_id?.background_image, (result) => {
          dispatch(
            updateContainerImage({
              selectedActivityIdx: selectedUserActivity,
              name: "bg_img.png",
              uri: result,
            })
          );
        });
      }
    }
  }, [master?.question_id?.background_image]);

  useEffect(() => {
    if (!master) return;
    changeStyles(master?.theme_id?.styles?.styles);
  }, [width, master?.question_id || {}, master?.theme_id?.styles]);

  useEffect(() => {
    if (!master) return;
    if (isMobile === true) {
      changeStyles(master?.theme_id?.styles?.styles)
    } else {
      let obj1 = { ...master?.theme_id?.styles?.styles }
      setStyles(obj1)
    }
  }, [isMobile]);

  if (!master) {
    return <></>;
  }

  const changeStyles = (initialStyles) => {
  
    // console.log('width', width)
    // console.log('isMobile', isMobile )
    // console.log('width', width <= 768 || isMobile === true)
    if (width <= 768 || isMobile === true) {
      let obj1 = { ...master?.theme_id?.styles?.styles };
      let obj2 = { ...master?.theme_id?.styles.mobileStyles };
      for (let key in obj1) {
        if (obj2[key]) {
          obj1[key] = { ...obj1[key], ...obj2[key] };
        }
      }
      setStyles(obj1);
    } else {
      setStyles(tempStyles);
    }
  };
  const { question, timer, answer, mcq_options, image, matchthefollowingoption_set, fillintheblankanswer_set, mcqoption_set, image_data, background_image, background_image_data } = Object(
    master?.question_id
    );
    let { active, styles: tempStyles, detail } = Object(master?.theme_id?.styles);
    // console.log('styles', styles)
    // console.log('userActivities', userActivities)

  return (
    <>
      {
        <div className={`activity_container__activity ${isMobile && previewModalOpen && width > 1275 ? 'mobile' : ''}`} ref={activityRef} onClick={handleClick}
        >
          <div
            className="activity_container__activity_wrapper"
            style={{
              ...styles?.container,
              ...(background_image !== null &&
                !background_image_data && {
                backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(${background_image})`,
              }),
              ...(background_image_data && {
                backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(${background_image_data?.uri})`,
              }),
              overflowY: 'auto'
            }}
          >
            {/* {isVideo ? <Video /> : ''} */}
            {active?.question && <Question question={question} style={styles} />}
            {active?.image && <Image styles={styles} src={image} image_data={image_data} update={update} />}
            {active?.answers && <Answers answers={mcqoption_set} style={styles} />}

            {active?.mtfQuestion && <MtfQuestion question={question} styles={styles} />}
            {active?.mtfOptionContainer && !detail.optionWithImage && <OptionsContainer options={matchthefollowingoption_set} styles={styles} />}
            {active?.mtfOptionContainer && detail.optionWithImage && <OptionsContainer optionWithImage={true} options={matchthefollowingoption_set} styles={styles} />}

            {active?.tAndFanswers && <TandF styles={styles} isTrueanswer={answer} />}

            {(active?.fillUpsSingleAnswer || active?.fillUpsMultipleAnswer) && <FillUpsAnswers styles={styles} active={active} answer_set={fillintheblankanswer_set} />}

            {/* --> Games <--  */}
            {active?.matchingPairs && <MatchingPairs question_id={master?.question_id} />}
            {active?.crosswords && <CrossWords master={master} style={styles} />}
            {!previewModalOpen && <Timer timer={timer} />}
            {previewModalOpen && timer >= 1 && <Timer timer={timer} />}
          </div>
        </div>
      }
    </>
  );
}
